import React from "react";
import ReactApexChart from "react-apexcharts";
import { useTitle } from "../../../../hooks/useTitle";
import { withAuth } from "../../../../components/HOC/withAuth";
import CardContainer from "../../../../components/CustomUI/CardContainer";
import { SectionSpinner, SectionEmpty } from "../shared/utils";
import { RP_SERIES } from "../shared/constants";
import QualityReportShell from "./QualityReportShell";
import { useQualityReport } from "./useQualityReport";

const QualityByPartReport = () => {
  useTitle("Rovion MES - Parça / Hurda Raporu");
  const {
    filters,
    machines,
    shifts,
    rows,
    loading,
    derived,
    handleApply,
    toasts,
    dismissToast,
  } = useQualityReport();

  const content = () => {
    if (loading) return <SectionSpinner />;
    if (!rows.length || !derived) return <SectionEmpty />;
    const { partArr } = derived;
    if (!partArr.length) return <SectionEmpty msg="Parça verisi bulunamadı." />;

    return (
      <CardContainer title="Parça / Hurda Raporu">
        <ReactApexChart
          type="bar"
          series={[
            { name: "Hurda Oranı %", data: partArr.map((p) => p.refusePct) },
          ]}
          options={{
            chart: { type: "bar", toolbar: { show: false } },
            plotOptions: { bar: { horizontal: true, borderRadius: 4 } },
            colors: [RP_SERIES.rejected],
            xaxis: {
              categories: partArr.map((p) => p.name || p.code),
              max: 100,
            },
            dataLabels: { enabled: true, formatter: (v) => `${v}%` },
            grid: { borderColor: "#f0f2f5" },
            tooltip: {
              y: { formatter: (v) => `${v}%` },
              custom: ({ dataPointIndex }) => {
                const p = partArr[dataPointIndex];
                return `<div class="p-2 small">Üretilen: ${p.produced.toLocaleString("tr-TR")}<br/>Hatalı: ${p.rejected.toLocaleString("tr-TR")}</div>`;
              },
            },
          }}
          height={Math.max(220, partArr.length * 42)}
        />
      </CardContainer>
    );
  };

  return (
    <QualityReportShell
      title="Parça / Hurda Raporu"
      filters={filters}
      machines={machines}
      shifts={shifts}
      onApply={handleApply}
      toasts={toasts}
      dismissToast={dismissToast}
    >
      {content()}
    </QualityReportShell>
  );
};

export default withAuth(QualityByPartReport);
